import CybersecurityMap from "../../../components/_maps/cyberSecurity/CybersecurityMap/CybersecurityMap";
import { useActions } from "../../../hooks/useActions";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { useEffect, useRef } from "react";
import useSearchParams from "../../../hooks/useSearchParams";
import MapPage from "../../../share/MapPage/MapPage";
import Filters from "../../../components/_maps/cyberSecurity/CybersecurityMapFilters/Filters";
import DownloadResults from "../../../components/_maps/main/DownloadResults/DownloadResults";
import CybersecurityMapDetails from "../../../components/_maps/cyberSecurity/CybersecurityMapDetails/CybersecurityMapDetails";
import CybersecurityMapSearchResults from "../../../components/_maps/cyberSecurity/CybersecurityMapSearchResults/CybersecurityMapSearchResults";

const CybersecurityPage = () => {
  const { viewport } = useTypedSelector((state) => state.mapInterface);
  const {
    setCybersecurityMapRef,
    getCurrentCybersecurityObject: getCurrentMapCybersecurity,
    setIsDetailsActive,
    setCurrentMarker,
  } = useActions();
  const { selectedObject } = useTypedSelector(
    (state) => state.mapCybersecurityInfo
  );
  const { cybersecurityMapRef } = useTypedSelector(
    (state) => state.mapObjectsInfo
  );
  const { id: accountId } = useTypedSelector((state) => state.currentAccount);

  const initMapRef = useRef(null);

  useEffect(() => {
    if (!cybersecurityMapRef) {
      setCybersecurityMapRef(initMapRef);
    }
  }, [cybersecurityMapRef]);

  const { getSearchParam } = useSearchParams();
  const hashId = getSearchParam("hash_id");

  useEffect(() => {
    if (hashId) {
      getCurrentMapCybersecurity(hashId, accountId);
    }
  }, [hashId]);

  useEffect(() => {
    if (selectedObject?.edrpou) {
      setCurrentMarker({
        lat: selectedObject?.location?.lat ? +selectedObject.location.lat : 0,
        lon: selectedObject?.location?.lon ? +selectedObject.location.lon : 0,
      });
      setIsDetailsActive(true);
      cybersecurityMapRef.current?.flyTo({
        center: [
          selectedObject?.location?.lon ? +selectedObject.location.lon : 0,
          selectedObject?.location?.lat ? +selectedObject.location.lat : 0,
        ],
        zoom: 15,
      });

      const latitude = selectedObject?.location?.lat
        ? +selectedObject.location.lat
        : 0;
      const longitude = selectedObject?.location?.lon
        ? +selectedObject.location.lon
        : 0;
      const zoom = viewport.zoom >= 12 ? viewport.zoom : 12;

      cybersecurityMapRef.current?.flyTo({
        center: [longitude, latitude],
        duration: 2000,
        zoom,
      });
    }
  }, [selectedObject]);

  const count = useTypedSelector((state) => state.mapCybersecurityInfo.count);
  const { isListViewActive } = useTypedSelector((state) => state.mapInterface);

  return (
    <MapPage
      filter={<Filters isListView={isListViewActive} />}
      SearchResults={CybersecurityMapSearchResults}
      downloadResults={
        <DownloadResults count={count} disabled noDownloadButton />
      }
      objectDetails={<CybersecurityMapDetails />}
      map={<CybersecurityMap />}
      mapRef={cybersecurityMapRef}
      setMapRef={setCybersecurityMapRef}
      keepMapMountedOnMobileListView
    ></MapPage>
  );
};

export default CybersecurityPage;
